function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgModaEBeleza = function SvgModaEBeleza(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1 3.51a1.75 1.75 0 00-1.833 1.747h-1a2.749 2.749 0 012.88-2.746 2.767 2.767 0 012.617 2.617 2.75 2.75 0 01-1.646 2.65 1 1 0 00-.601.916v.639c.436.118.835.384 1.115.783l6.74 9.624c1.02 1.46-.231 3.426-1.986 3.117L2.022 19.97c-1.754-.31-2.259-2.586-.8-3.607l9.625-6.739c.209-.146.436-.247.67-.305v-.626a2 2 0 011.2-1.832 1.75 1.75 0 001.048-1.688A1.767 1.767 0 0012.1 3.51zM1.796 17.183c-.73.51-.477 1.649.4 1.803l16.363 2.886c.878.155 1.504-.828.994-1.558l-6.74-9.624a1 1 0 00-1.392-.246l-9.625 6.739z",
    fill: props.color
  }));
};
SvgModaEBeleza.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgModaEBeleza.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgModaEBeleza;